<div
  class="main-menu fixed top-0 left-0 z-50 flex h-screen w-full flex-col bg-white transition duration-[400ms] ease-in-out md:hidden"
  [ngClass]="isShowDrawer ? 'translate-y-0' : 'translate-y-[100vh]'">
  <div class="header sticky top-0 flex items-center gap-3 border-b bg-white">
    <button class="p-3" (click)="toggle()">
      <fa-icon [icon]="faChevronLeft" class="text-xl text-gray-500"></fa-icon>
    </button>
    <h2 class="text-lg font-medium">{{ title }}</h2>
  </div>
  <div class="overflow-y-auto p-3 text-primary-darkest">
    <ng-content></ng-content>
  </div>
</div>
